var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cell-num-wrapper",style:(_vm.selfStyle),on:{"click":_vm.onCellClick}},[_c('span',{staticClass:"num-p"},[_vm._v(_vm._s(_vm.num))])])}
var staticRenderFns = []

export { render, staticRenderFns }